<template>
  <div class="container account-page">
    <block-breadcrumbs :items="breadcrumbs" />
    <page-head
      title="Личный кабинет"
    />
    <div class="wrapper">
      <aside>
        <ul>
          <li v-for="(n, i) in nav" :key="i">
            <a
              :href="n.path"
              :class="['nav-link', 'txt-overflow', { active: n.path === $route.path }]"
            >
              {{ n.name }}
              <ui-badge size="large" max-width="94" :text="n.badgeText" :color="n.badgeColor" />
              <f-sprite-icon :icon-link="n.icon" v-if="n.icon" />
            </a>
          </li>
        </ul>
      </aside>
      <div class="content">
        <router-view />
      </div>
    </div>

    <product-gallery-recently-viewed
      v-if="isFavTabActive"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

/* Icons */
import IconExit from '../../assets/icons/exit.svg';

/* Components */
import blockBreadcrumbs from '../../components/breadcrumbs/breadcrumbs';
import PageHead from '../../components/common/page-head.vue';
import ProductGalleryRecentlyViewed from '@/components/product-gallery-recently-viewed/product-gallery-recently-viewed.vue';

export default {
  name: 'page-profile',
  components: {
    blockBreadcrumbs,
    PageHead,
    ProductGalleryRecentlyViewed,
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters({
      LOGGED_IN: 'user/loggedIn',
      BONUSES: 'user/bonuses',
    }),

    breadcrumbs() {
      const bc = [{ id: 'b', path: '/account', name: 'Личный кабинет' }];
      const current = this.nav.find(({ path }) => path === this.$route.path);
      if (current) {
        bc.push({ ...current, ...{ id: 'c' }});
      }
      return bc;
    },

    nav() {
      return [
        {
          name: 'Клубная программа',
          path: '/account/club',
          badgeText: `${this.$options.filters.price(this.BONUSES)} ${this.$options.filters.decl(this.BONUSES, 'бонус', ['', 'а', 'ов'])}`,
          badgeColor: '#95D4E9',
        },
        {
          name: 'Профиль',
          path: '/account',
        },
        {
          name: 'Заказы',
          path: '/account/orders',
        },
        {
          name: 'Адреса',
          path: '/account/addresses',
        },
        {
          name: 'Избранное',
          path: '/account/favorites',
        },
        {
          name: 'Уведомления',
          path: '/account/promotions',
        },
        {
          name: 'Подписки',
          path: '/account/subscribes',
        },
        {
          name: 'Выход',
          path: '/account/logout',
          icon: IconExit.id,
        },
      ]
    },

    isFavTabActive() {
      return this.$router.currentRoute.name === 'AccountFavorites'
    },
  },
  serverPrefetch() {
    if (!this.LOGGED_IN) {
      return Promise.reject({ status: 302, redirect: `/#register` });
    }
  },
};
</script>

<style lang="scss">
.account-page {
  .wrapper {
    padding-bottom: 48px;
  }
  aside {
    display: none;
  }

  h2 {
    font-weight: 400;
    margin: 0;
    font-size: 20px;
    line-height: 28px;
  }
  .sprite-icon {
    width: 24px;
    height: 24px;
  }
}

@include breakpoint("tablet") {
  .account-page {
    .page-head {
      padding-bottom: 15px;
    }

    .wrapper {
      padding-bottom: 80px;
    }
  }
}

@include breakpoint("desktop") {
  .account-page {
    .page-head {
      margin-top: 0;
    }

    .wrapper {
      display: flex;
      margin-top: 40px;
      padding-bottom: 120px;
      .content {
        flex: 1;
        width: calc(100% - 312px);
      }
    }
    aside {
      display: block;
      width: 272px;
      margin-right: 40px;
      ul {
        list-style: none;
        padding: 8px 0;
        border-radius: 4px;
        border: 1px solid $gray_lu;
        li:not(:last-child) {
          box-shadow: inset 0 -1px 0 $gray_lu;
          padding-bottom: 1px;
        }
        li:last-child {
          color: $gray;
        }
      }
    }
    .nav-link {
      position: relative;
      display: flex;
      padding: 12px 16px;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      white-space: nowrap;

      &:hover,
      &.active {
        background: $gray_bgr;
      }
      &.active {
        &::before {
          content: '';
          position: absolute;
          left: -1px;
          top: -1px;
          bottom: -1px;
          width: 2px;
          background: $black;
        }
      }
      > *:last-child {
        margin-left: auto;
      }

      .ui-badge {
        margin-left: 10px;
      }
    }
    h2 {
      font-size: 24px;
      line-height: 32px;
    }
  }
}
</style>
